import { useEffect, useState } from "react";
import { Plus, Trash2, UserRound } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, apiError } from "../../lib/api";

export const useFrequent = () => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/my/passengers").then((r) => setList(Array.isArray(r.data) ? r.data : [])).catch(() => {}); }, []);
  return [list, setList];
};

export const fillWith = (seats, pax, p) => {
  if (seats.some((s) => pax[s]?.dni === p.dni)) return pax;
  const s = seats.find((x) => !(pax[x]?.name ?? "").trim() && !(pax[x]?.dni ?? ""));
  return s == null ? pax : { ...pax, [s]: { name: p.name, dni: p.dni } };
};

export const FrequentChips = ({ list, seats, pax, onPick }) => (list.length ? (
  <div data-testid="frequent-chips" className="flex flex-wrap gap-2">
    <span className="w-full text-xs text-[var(--muted-ink)]">Tocá un pasajero frecuente para completar la próxima butaca libre:</span>
    {list.map((p) => {
      const used = seats.some((s) => pax[s]?.dni === p.dni);
      return (
        <button key={p.dni} type="button" disabled={used} onClick={() => onPick(p)} data-testid={`frequent-chip-${p.dni}`}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${used ? "bg-[var(--lime)] text-[var(--ink)]" : "bg-[var(--paper)] hover:bg-[var(--lime)]/50"}`}>
          <UserRound className="h-3.5 w-3.5" /> {p.name}
        </button>
      );
    })}
  </div>
) : null);

export const FrequentManager = () => {
  const [list, setList] = useFrequent();
  const [f, setF] = useState({ name: "", dni: "" });
  const add = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/my/passengers", f); setList(data ?? []); setF({ name: "", dni: "" }); } catch (err) { toast.error(apiError(err)); }
  };
  const del = async (dni) => {
    try { const { data } = await api.delete(`/my/passengers/${dni}`); setList(data ?? []); } catch (err) { toast.error(apiError(err)); }
  };
  return (
    <div data-testid="frequent-manager" className="space-y-3">
      <p className="text-xs text-[var(--muted-ink)]">Se guardan solos cada vez que comprás. Los usás con un toque al elegir butacas.</p>
      {list.length > 0 && (
        <div className="divide-y divide-black/5 rounded-2xl ring-1 ring-black/5">
          {list.map((p) => (
            <div key={p.dni} data-testid={`frequent-row-${p.dni}`} className="flex items-center justify-between gap-3 px-4 py-2.5 text-sm">
              <span><b>{p.name}</b> · DNI {p.dni}</span>
              <button onClick={() => del(p.dni)} data-testid={`frequent-delete-${p.dni}`} aria-label={`Borrar ${p.name}`} className="text-red-700"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
      <form onSubmit={add} className="grid grid-cols-[1fr_7rem_auto] gap-2">
        <Input data-testid="frequent-name" required minLength={2} placeholder="Nombre y apellido" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="h-11 min-w-0 rounded-xl" />
        <Input data-testid="frequent-dni" required inputMode="numeric" pattern="\d{6,10}" title="Solo números, 6 a 10 dígitos" placeholder="DNI" value={f.dni} onChange={(e) => setF({ ...f, dni: e.target.value.replace(/\D/g, "") })} className="h-11 min-w-0 rounded-xl" />
        <button data-testid="frequent-add" aria-label="Agregar pasajero" className="grid h-11 w-11 place-items-center rounded-xl bg-[var(--forest)] text-white"><Plus className="h-4 w-4" /></button>
      </form>
    </div>
  );
};
